import { baseApi } from '../../../core/baseApi';
import {
  createGetByIdQuery,
  unwrapApiResponse
} from '../../../patterns/crud';
import { Organization } from '../types';

// CRITICAL: Changed from organizationApi to organizationsApi (plural)
export const organizationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationDetails: createGetByIdQuery<Organization>('organizations', 'Organization')(builder),
    updateOrganization: builder.mutation<Organization, { organizationId: string; data: Partial<Organization> }>({
      query: ({ organizationId, data }) => ({
        url: `organizations/${organizationId}/me`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: unwrapApiResponse<Organization>,
      invalidatesTags: (_result, _error, { organizationId }) => [
        { type: 'Organization', id: organizationId },
        { type: 'Organization', id: 'LIST' }
      ],
    }),
    getOrganizationPhoneNumbers: builder.query<unknown, string>({
      query: (id) => `organizations/${id}/phone-numbers`,
      transformResponse: unwrapApiResponse<unknown>,
      providesTags: (_result, _error, id) => [
        { type: 'PhoneNumbers', id },
        { type: 'PhoneNumbers', id: 'LIST' }
      ],
    }),
    getOrganizationConsentSettings: builder.query<
      { consent_message: string; auto_append_first_message: boolean },
      string
    >({
      query: (organizationId) => `organizations/${organizationId}/consent-settings`,
      transformResponse: unwrapApiResponse<{ consent_message: string; auto_append_first_message: boolean }>,
      providesTags: (_result, _error, id) => [
        { type: 'Settings', id: `consent-${id}` },
      ],
    }),
    // Correct onboarding-specific updater hitting /organizations/:organization_id/onboarding
    updateOrganizationOnboarding: builder.mutation<Organization, { organizationId: string; data: {
      companySize: string;
      clientCount: string;
      industry: string;
      industryOther?: string;
      currentSoftware: string[];
      softwareOther?: string;
      businessGoals?: string;
    } }>({
      query: ({ organizationId, data }) => ({
        url: `organizations/${organizationId}/onboarding`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: unwrapApiResponse<Organization>,
      invalidatesTags: (_result, _error, { organizationId }) => [
        { type: 'Organization', id: organizationId },
        { type: 'Organization', id: 'LIST' }
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetOrganizationDetailsQuery,
  useUpdateOrganizationMutation,
  useGetOrganizationPhoneNumbersQuery,
  useGetOrganizationConsentSettingsQuery,
  useUpdateOrganizationOnboardingMutation,
} = organizationsApi;